import styled from "styled-components";

export const DesktopDashboard = styled.div`
  display: none;
  @media (min-width: 769px) {
    display: block;
    position: inherit;
    overflow-x: auto;
    width: 100%;
  }
`;
